import './Header.scss'
import yearHorizontal from "../../assets/yearHorizontal.svg";
import yearVertical from "../../assets/yearVertical.svg";
import { Content } from "../../components"
import { useData } from "../../hooks/useData"

export function Header() {
  const { orientation } = useData()

  return (
    <header className={orientation}>

      <Content />

      { orientation === 'horizontal' && <img className="year" src={yearHorizontal} alt="" /> }
      { orientation === 'vertical' && <img className="year" src={yearVertical} alt="" /> }
    </header>
  )
}